import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Euro, CheckCircle, Clock, AlertCircle } from 'lucide-react';

interface TransactionSummaryCardsProps {
  total: number;
  matched: number;
  pendingReview: number;
  unreconciled: number;
}

export function TransactionSummaryCards({
  total,
  matched,
  pendingReview,
  unreconciled,
}: TransactionSummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total</CardTitle>
          <Euro className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{total.toFixed(2)} €</div>
          <p className="text-xs text-muted-foreground">Toutes transactions</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Rapprochées</CardTitle>
          <CheckCircle className="h-4 w-4 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">{matched}</div>
          <p className="text-xs text-muted-foreground">Confirmées</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">En révision</CardTitle>
          <Clock className="h-4 w-4 text-yellow-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-yellow-600">{pendingReview}</div>
          <p className="text-xs text-muted-foreground">À vérifier</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Non rapprochées</CardTitle>
          <AlertCircle className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{unreconciled}</div>
          <p className="text-xs text-muted-foreground">À traiter</p>
        </CardContent>
      </Card>
    </div>
  );
}
